import { render, staticRenderFns } from "./StrengthsCategory.vue?vue&type=template&id=4ea757fd&"
import script from "./StrengthsCategory.vue?vue&type=script&lang=js&"
export * from "./StrengthsCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports